// models component
import Favorite from '@/models/Favorite'

export default class Fetch {
    // Ship Management DashBoard Data Fetch
    static of() {
        return Promise.resolve()
            .then(function () {
                return Favorite.api()
                    .fetch()
                    .then(function (result) {
                        console.log('Favorite.all()', Favorite.all())
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
